import { Menu, MenuItem } from '@material-ui/core';

import styled from 'styled-components';

import { fontFamily } from '../../../../libs';

export const MenuStyled = styled(Menu)`
  span {
    font-family: ${fontFamily}!important;
    font-size: 14px !important;
  }

  button > span {
    color: #fff;
  }

  svg {
    font-size: 25px !important;
  }
`;

export const MenuItemStyled = styled(MenuItem)`
  margin: 2.5px;

  svg {
    color: #333;
  }
`;

export const MenuItemExit = styled(MenuItem)`
  margin: 2.5px;
  &:hover {
    background: #d32f2f20 !important;
  }

  * {
    color: red !important;
  }
`;

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
`;
